import { createSelector } from "reselect";
import moment from "moment";
import { get, sortBy } from "lodash";

import { getPageContent } from "shared/selectors";

const getDueMessage = deadline => {
  if (deadline.due_in > 0) {
    return `Fällig in ${deadline.due_in} Tagen.`;
  }
  if (deadline.due_in < 0) {
    return `Seit ${Math.abs(deadline.due_in)} Tagen überfällig.`;
  }
  return "Heute fällig";
};

const getIcon = deadline => {
  if (deadline.completed) {
    return {
      name: "check circle outline",
      color: "green",
      title: "Erledigt"
    };
  }
  if (deadline.due_in > 7) {
    return {
      name: "circle outline",
      color: null,
      title: getDueMessage(deadline)
    };
  }
  if (deadline.due_in >= 0) {
    return {
      name: "circle",
      color: "orange",
      title: getDueMessage(deadline)
    };
  }
  return {
    name: "circle",
    color: "red",
    title: getDueMessage(deadline)
  };
};

export const getDeadlines = createSelector([getPageContent], pageContent => {
  const dls = get(pageContent, ["deadlines", "unit", "deadlines"], [])
    .filter(deadline => {
      return deadline.scheduled_for === "buyer";
    })
    .map(deadline => ({
      title: deadline.title,
      description: deadline.description,
      due_in: deadline.due_in,
      expires_at: moment(deadline.expires_at),
      completed: deadline.completed,
      icon: getIcon(deadline)
    }));

  return sortBy(dls, deadline => {
    return deadline.due_in;
  });
});

export const getDeadlineStatistics = createSelector(
  [getDeadlines],
  deadlines => {
    const base = {
      close: 0,
      overdue: 0
    };
    return deadlines.reduce((accu, deadline) => {
      if (deadline.due_in < 7 && deadline.due_in >= 0) {
        accu.close += 1;
      }
      if (deadline.due_in < 0) {
        accu.overdue += 1;
      }
      return accu;
    }, base);
  }
);

export const getDeadlinesCount = createSelector([getDeadlines], deadlines => {
  return deadlines.length;
});
